export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'A carrer',
        name_es: 'A calle',
        name_en: 'To the street'
    }, {
        id: 3,
        name_ca: 'A pati interior',
        name_es: 'A patio interior',
        name_en: 'Interior courtyard'
    }, {
        id: 4,
        name_ca: 'A interior d\'illa',
        name_es: 'Interior de manzana',
        name_en: 'Block interior'
    }, {
        id: 5,
        name_ca: 'A parc',
        name_es: 'A parque',
        name_en: 'To the park'
    }, {
        id: 6,
        name_ca: 'A jardí',
        name_es: 'A jardín',
        name_en: 'To the garden'
    }, {
        id: 7,
        name_ca: 'A mar',
        name_es: 'Al mar',
        name_en: 'To the sea'
    }, {
        id: 8,
        name_ca: 'A muntanya',
        name_es: 'A la montaña',
        name_en: 'To the mountain'
    }, {
        id: 9,
        name_ca: 'A camp',
        name_es: 'Al campo',
        name_en: 'To the countryside'
    }, {
        id: 10,
        name_ca: 'Bones',
        name_es: 'Buenas',
        name_en: 'Good'
    }, {
        id: 10,
        name_ca: 'No gaire bones',
        name_es: 'No muy buenas',
        name_en: 'Poor'
    }
]





// WEBPACK FOOTER //
// ./src/options/views.js